export default "__VITE_ASSET__315f7cf2__"